<template>
  <div class="flex flex-col justify-center items-center">
    <div class="w-full max-w-md p-6 border border-gray-500 rounded-sm">
      <!-- タイトル -->
      <div class="mb-6 border-b-2 pb-2 text-center">
        <slot name="title" />
      </div>

      <!-- フォーム本体 -->
      <div class="space-y-4">
        <slot />
      </div>
    </div>

    <!-- 下の追加エリア -->
    <div class="mt-5 w-full max-w-md flex justify-center">
      <slot name="bottom" />
    </div>
  </div>
</template>
